import { CSSProperties } from 'react';
import styled from 'styled-components';
import CSS from 'csstype';

/**
 * Used for validation and Icon's `type` prop.
 */
export const IconTypes = {
  eyeOpen: 'eye-open',
  eyeClosed: 'eye-closed',
  dashboard: 'dashboard',
  moneySheet: 'money-sheet',
  inspect: 'inspect',
  puzzle: 'puzzle',
  help: 'help',
  logOut: 'log-out',
  search: 'search',
  globe: 'globe',
  hambar: 'hambar',
  arrowLeft: 'arrow-left',
  music: 'music',
  cornerPuzzle: 'corner-puzzle',
  stepBack: 'step-back',
  bulb: 'bulb',
  battery: 'battery',
  wifi: 'wifi',
  signal: 'signal',
  close: 'close',
  undo: 'undo',
  rotate: 'rotate',
  solidPuzzle: 'solidPuzzle',
  preview: 'perview',
  pencil: 'pencil',
  album: 'album',
  editImage: 'edit-image',
  trash: 'trash',
  check: 'check',
  status: 'status',
  calendar: 'calendar',
  like: 'like',
  play: 'play',
  keywords: 'keywords',
  categories: 'categories',
  category: 'category',
  document: 'document',
  imageResolution: 'imageResolution',
  openLink: 'openLink',
  exclamationMark: 'exclamationMark',
  reset: 'reset',
  warningSign: 'warning-sign',
  camera: 'camera',
  image: 'image',
} as const;

export type IconTypesKeys = keyof typeof IconTypes;
export type IconTypesValues = typeof IconTypes[IconTypesKeys];

/**
 * Predefined icon sizes.
 * Use style property instead for one-off cases.
 */
export const iconSizes = {
  /** X icon in added images section. */
  small: '20px',

  /** Notification icons, view puzzle preview icon. */
  medium: '24px',

  /** Most other icons */
  large: '32px',
};

interface IconStyleProps {
  cursor?: CSS.Property.Cursor;
  background?: CSS.Property.Background;
}

const IconStyle = styled.svg<IconStyleProps>`
  display: inline-block;
  background: ${({ background }) => background || null};
  color: ${({ color }) => (color ? color : 'rgb(63, 63, 63)')};
  cursor: ${({ cursor }) => (cursor ? cursor : undefined)};
`;

interface IconProps {
  width: string | number;
  height: string | number;
  type: IconTypesValues;
  color?: CSS.Property.Color;
  background?: CSS.Property.Background;
  cursor?: CSS.Property.Cursor;
  children?: React.ReactNode;
  style?: CSSProperties;
  onClick?(): void;
}

const Icon = ({ children, type, color, width, height, style, ...props }: IconProps) => {
  return (
    <IconStyle fill="none" color={color} width={width} height={height} style={style} {...props}>
      <use href={`/assets/images/icons.svg#${type}`} />
      {children}
    </IconStyle>
  );
};

export default Icon;
